import { render, staticRenderFns } from "./ActiveProductsList.vue?vue&type=template&id=0c0d3566&lang=pug"
import script from "./ActiveProductsList.vue?vue&type=script&lang=js"
export * from "./ActiveProductsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Spinner: require('/home/docker/code/frontend/components/Spinner.vue').default})
